import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './app.shared.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateService } from '@ngx-translate/core';

import { httpInterceptorProviders  } from './_helpers';

import { MatPaginatorIntl } from '@angular/material/paginator';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { getPaginatorIntl } from './components/paginator.i18n.provider';
import { BlockUIModule } from 'ng-block-ui';

import { LoginDialog } from './login/login.dialog';
import { LoginComponent } from './login/login.component';
import { LOGIN_CambioClave_Dialog } from './login/login.cambioclave/login.cambioclave.dialog';
import { LOGIN_RecuperarClave_Dialog } from './login/login.recuperarclave/login.recuperarclave.dialog';

import { NgxSpinnerModule } from "ngx-spinner";

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LoginDialog,
    LOGIN_CambioClave_Dialog,
    LOGIN_RecuperarClave_Dialog,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
    SharedModule.forRoot(),
    BlockUIModule.forRoot(),
  ],
  entryComponents: [
    LoginDialog,
    LOGIN_CambioClave_Dialog,
    LOGIN_RecuperarClave_Dialog
  ],
  providers: [ 
    httpInterceptorProviders,
    // { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: MAT_DATE_LOCALE, useValue: 'es-CO' },
    { provide: MatPaginatorIntl, useFactory: getPaginatorIntl, deps: [TranslateService] }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
